var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Rahmen",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 106",
    style: {
      enableBackground: "new 0 0 110 106"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,21v44h40V21H35z M73,63H37V23h36V63z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.6,42.2c0-4.6,3.7-8.4,8.4-8.4v-6l-11.8,3.1c0,0-2.9,22,11.8,27.2v-7.6C50.4,50.6,46.6,46.8,46.6,42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.8,30.9L55,27.8v6c4.6,0,8.4,3.7,8.4,8.4s-3.7,8.4-8.4,8.4v7.6C69.7,52.9,66.8,30.9,66.8,30.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55,35.3c1.8,0,3.3,1.5,3.3,3.3s-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3S53.2,35.3,55,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.5,47.5c-1.5,1.9-3.9,3.1-6.5,3.1c-2.6,0-4.9-1.2-6.5-3.1c1-2.6,3.5-4.4,6.5-4.4S60.5,44.9,61.5,47.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsDefault);
export default __webpack_public_path__ + "static/media/accounts-default.6d3cfa6cd2f275205a4c04a59fa5db16.svg";
export { ForwardRef as ReactComponent };